import { css, RuleSet } from 'styled-components';

type MediaQueryFn = (innerCSS: RuleSet) => RuleSet;

export const mobile: MediaQueryFn = (innerCSS) => css`
  @media (max-width: 320px) {
    ${innerCSS};
  }
`;

export const tablet: MediaQueryFn = (innerCSS) => css`
  @media (max-width: 768px) {
    ${innerCSS};
  }
`;

export const laptop: MediaQueryFn = (innerCSS) => css`
  @media (max-width: 1024px) {
    ${innerCSS};
  }
`;
